<template>
  <div v-if="payInfo">
    <div v-if="isSeparate" class="layer paymentLayer">
      <div class="inner">
        <p class="layerTitle">결제를 시작합니다.</p>
        <div class="btns">
          <button type="button" class="btn btnPrimary btnFull" @click.stop="paySubmit">결제하기</button>
        </div>
      </div>
    </div>
    <form name="payForm" id="payForm" method="post" target="_self" accept-charset="euc-kr">
      <!--CODclearfa  /   INIpayTest -->
      <input type="hidden" name="GoodsName" :value="payInfo.GoodsName" />
      <input type="hidden" name="Amt" :value="payInfo.Amt" />
      <input type="hidden" name="MID" :value="payInfo.MID" />
      <input type="hidden" name="EdiDate" :value="payInfo.EdiDate" />
      <input type="hidden" name="Moid" :value="payInfo.Moid" />
      <input type="hidden" name="SignData" :value="payInfo.SignData" />
      <input type="hidden" name="ReturnURL" :value="payInfo.ReturnURL" />
      <input type="hidden" name="PayMethod" :value="payInfo.PayMethod" />
      <input type="hidden" name="CharSet" :value="payInfo.CharSet" />
    </form>
  </div>
</template>

<script>
export default {
  name: 'NicePayment',
  props: [
    'locale'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        setTimeout(() => {
          this.paySubmit()
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false
    }
  },
  methods: {
    paySubmit () {
      const actionUrl = 'https://web.nicepay.co.kr/v3/v3Payment.jsp'
      const f = document.payForm
      f.action = actionUrl
      f.submit()
      this.$emit('close')
      this.$destroy()
    },
    closePayment (e) {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        e.preventDefault()
        window.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentLayer {
  .inner {
    padding: 45px 30px;
    border-radius: 8px;
  }
  .layerTitle {
    text-align: center;
  }
  .btns {
    margin-top: 30px;
    .btn {
      padding-top: 1em;
      padding-bottom: 1em;
      border-radius: 8px;
    }
  }
}
</style>
